import FeedbackViewListing from "./FeedbackViewListing";
import { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import styled from "styled-components";
import CustomSelect from "Components/CommonComponents/CustomSelect";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import OverrallRating from "Pages/Faculties/Ratings/OverrallRating";
import ReviewRating from "Assets/Images/ReviewRating.png";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";

export interface GetAssetsIF {
  nodeId: number;
  nodeTitle: string;
  marked: boolean;
  nodeType: string | null;
  enabled: boolean;
}
interface FeedbackViewModalIF {
  mode?: string;
  isLectureViewModal: boolean;
  setIsLectureViewModal: any;
  selectedlecture?: any;
  editHandler?: any;
  facultyFeedbackData?: any;
  setYearMonthForFeedback: any;
  dateFilterValues?: any;
}
const MyRatingDiv = styled<any>("div")`
  color: var(--Grey-Grey-90, #262626);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 140% */
`;
const DivMarked = styled<any>("div")`
  font-weight: 700;
  font-size: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "16px" : "24px"};
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen)
      ? ""
      : "0.5px solid var(--Grey-50, #AFAFAF)"};
  padding: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "" : "0px 0px 8px 0px"};
`;
const MainDiv = styled<any>("div")`
  display: flex;
  flex-direction: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "row" : "column"};
  width: 100%;
  padding-bottom: 24px;
  padding-top: 16px;
`;
const Div1 = styled<any>("div")`
  width: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "100%" : "40%"};
  border-right: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "" : "0.5px dashed #afafaf"};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Div2 = styled<any>("div")`
  width: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "100%" : "60%"};
`;
const ReviewRatingDiv = styled<any>("div")`
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: var(--Yellow-10, #fff6e3);
  color: var(--Yellow-70, #a17217);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;
const FeedbackViewModal = ({
  mode,
  isLectureViewModal,
  setIsLectureViewModal,
  selectedlecture,
  facultyFeedbackData,
  setYearMonthForFeedback,
  dateFilterValues,
}: FeedbackViewModalIF) => {
  const { screen }: any = useWindowSize();
  const [lectureAssetsData, setlectureAssetsData] = useState<GetAssetsIF[]>([]);
  const [dateFilter, setDateFilter] = useState<any>(dateFilterValues?.[0]);
  useEffect(() => {
    // if (Object.keys(selectedlecture).length) {
    //   const url = BASE_URL + GET_ASSETS_WITH_SM_ID;
    //   const obj = {
    //     lectureId: selectedlecture?.fexRecordId,
    //   };
    //   PostGetAssets(url, obj);
    // }
    console.log("Checking here", lectureAssetsData);
    setlectureAssetsData([]);
  }, [selectedlecture]);
  const MarkedLectureDiv = () => (
    <DivMarked screen={screen}>
      <MyRatingDiv>My Ratings</MyRatingDiv>
      <div className="w-50">
        <CustomSelect
          isSelected={true}
          width={"100%"}
          top={"-3px"}
          placeholder="Date"
          options={dateFilterValues}
          isSearchable={false}
          menuPlacement="bottom"
          isClearable={false}
          menuShouldScrollIntoView={true}
          closeMenuOnSelect={true}
          onChange={(selected: any) => {
            setDateFilter(selected);
            setYearMonthForFeedback(selected.value);
          }}
          value={dateFilter}
        />
        {/* <Col /> */}
      </div>
    </DivMarked>
  );
  const processResponseForCardData = (data: any, aggregatedData: any): [] => {
    if (data !== null) {
      Object.keys(data).forEach((key) => {
        if (Object.hasOwnProperty.call(data, key)) {
          aggregatedData.push({
            type: key,
            value: data[key],
          });
        }
      });
    }
    return aggregatedData;
  };
  const Toggle = () => {
    setIsLectureViewModal(!isLectureViewModal);
  };

  return (
    <>
      <Modal
        isOpen={isLectureViewModal}
        centered={true}
        backdrop={true}
        size={"md"}
        fullscreen={true}
        toggle={Toggle}
        className={
          ["xs", "sm", "md"].includes(screen)
            ? "syllabusModal"
            : "syllabusModalDK"
        }
      >
        <div
          className={
            ["xs", "sm", "md"].includes(screen)
              ? "feedbackViewModalBodyMB"
              : "feedbackViewModalBody"
          }
        >
          {mode === "myBatchLecture" && <MarkedLectureDiv />}
          {facultyFeedbackData && facultyFeedbackData.length === 0 ? (
            <div className="mt-4 mb-8">
              <NoResultFoundSearch
                primaryMessage="Feedback data not available"
                secondaryMessage={""}
              >
                <NoDataFoundIcon />
              </NoResultFoundSearch>
            </div>
          ) : (
            <MainDiv screen={screen}>
              <Div1 screen={screen}>
                <OverrallRating
                  ratingValue={facultyFeedbackData[0].overallRatingResponseAvg}
                ></OverrallRating>
              </Div1>
              <Div2 screen={screen}>
                <FeedbackViewListing
                  Loader={false}
                  data={processResponseForCardData(facultyFeedbackData[0], [])}
                ></FeedbackViewListing>
              </Div2>
            </MainDiv>
          )}
          {facultyFeedbackData &&
            facultyFeedbackData[0] &&
            facultyFeedbackData[0].weightedNumberOfFeedback !== 0 && (
              <ReviewRatingDiv>
                <img src={ReviewRating} />
                Based on {facultyFeedbackData[0].weightedNumberOfFeedback}{" "}
                reviews
              </ReviewRatingDiv>
            )}
        </div>
      </Modal>
    </>
  );
};
export default FeedbackViewModal;
